import { render, staticRenderFns } from "./BoxDetailCard.vue?vue&type=template&id=68a0152c&"
import script from "./BoxDetailCard.vue?vue&type=script&lang=js&"
export * from "./BoxDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./BoxDetailCard.vue?vue&type=style&index=0&id=68a0152c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports